/*
 * "Fly to cart": a small clone of the product cover arcs from the element
 * that was clicked to the header cart button (`[data-cart-target]`), then
 * fades. Purely decorative — the cart store has already been updated by the
 * time this runs. Skipped under `prefers-reduced-motion` or when either end
 * is off-screen.
 */

const FLIGHT_MS = 650;
const CLONE_W = 56;
const CLONE_H = 72;

export function flyToCart(from: Element | null | undefined, image: string | null | undefined) {
  if (!from || !image || typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const target = document.querySelector<HTMLElement>('[data-cart-target]');
  if (!target) return;

  const a = from.getBoundingClientRect();
  const b = target.getBoundingClientRect();
  if (a.width === 0 || b.width === 0) return;

  const clone = document.createElement('img');
  clone.src = image;
  clone.alt = '';
  clone.setAttribute('aria-hidden', 'true');
  Object.assign(clone.style, {
    position: 'fixed',
    zIndex: '90',
    left: `${a.left + a.width / 2 - CLONE_W / 2}px`,
    top: `${a.top + a.height / 2 - CLONE_H / 2}px`,
    width: `${CLONE_W}px`,
    height: `${CLONE_H}px`,
    objectFit: 'cover',
    borderRadius: '8px',
    pointerEvents: 'none',
    boxShadow: '0 12px 32px rgba(0,0,0,.5)',
  } satisfies Partial<CSSStyleDeclaration>);
  document.body.appendChild(clone);

  const dx = b.left + b.width / 2 - (a.left + a.width / 2);
  const dy = b.top + b.height / 2 - (a.top + a.height / 2);
  const anim = clone.animate(
    [
      { transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0 },
      { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 80}px) scale(0.7)`, opacity: 1, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.15)`, opacity: 0.2, offset: 1 },
    ],
    { duration: FLIGHT_MS, easing: 'cubic-bezier(0.3, 0, 0.2, 1)', fill: 'forwards' },
  );
  anim.onfinish = () => {
    clone.remove();
    target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 260, easing: 'ease-out' });
  };
}
